import { useEffect, useState } from 'react'
import { registerSW } from 'virtual:pwa-register'

export interface PwaUpdate {
  readonly ready: boolean
  readonly offlineReady: boolean
  readonly apply: () => void
  readonly dismiss: () => void
}

/**
 * A new version never applies itself. It waits here until someone accepts it,
 * which is the whole reason `registerType` is `prompt`.
 */
export function usePwaUpdate(): PwaUpdate {
  const [ready, setReady] = useState(false)
  const [offlineReady, setOfflineReady] = useState(false)
  const [update, setUpdate] = useState<(() => Promise<void>) | null>(null)

  useEffect(() => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh: () => {
        setReady(true)
        setUpdate(() => async () => updateSW(true))
      },
      onOfflineReady: () => {
        setOfflineReady(true)
      },
    })
  }, [])

  return {
    ready,
    offlineReady,
    apply: () => {
      void update?.()
    },
    dismiss: () => {
      setReady(false)
    },
  }
}
